// state
export const state = () => ({
	loading: false,
	regulations: []
})

// Actions
export const actions = {

	// Get regulation
	async getRegulation({ commit }) {
		try {
			commit('setLoading', true)
			await this.$axios.get(`/pra/regulation`).then(response => {
				commit('setReguration', response.data.data)
				commit('setLoading', false)
			}).catch(() => {
				commit('setLoading', false)
			})
		} catch (error) {
			commit('setLoading', false)
		}

	},
}

// Mutations
export const mutations = {
	setLoading(state, val) {
		state.loading = val
	},
	setReguration: (state, val) => {
		state.regulations = val
	}
}


// Getters
export const getters = {
	loading: state => state.loading,
	regulations: state => state.regulations
}